
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promocoes/[categorySlug]/s",
      function () {
        return require("private-next-pages/promocoes/[categorySlug]/s.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promocoes/[categorySlug]/s"])
      });
    }
  